<template>
  <MLabel
    class="flex grow"
    :class="{ 'relative cursor-pointer hover:underline': details }"
    :type="type"
  >
    <div>
      <slot>
        <span v-if="messageKey" class="font-semibold">{{ $t(messageKey) }}</span>
      </slot>
      <span v-if="details" class="hidden lg:inline underline">
        {{ $t('details') }}
      </span>
    </div>
    <button v-if="details" class="block absolute inset-0" @click="modalOpen = true" />
    <MModal v-if="details && modalOpen" @close="modalOpen = false" modal-class="md:max-w-lg">
      <slot name="modalContent">
        <BackgroundImage
          class="h-16 max-w-1/3 mx-auto my-5"
          size="contain"
          :src="provider.logo.sm"
          :alt="provider.displayName"
        />
        <p class="mx-8 mb-8">{{ details }}</p>
      </slot>
    </MModal>
  </MLabel>
</template>

<script lang="ts" setup>
import type { Provider } from './types'
import type { LabelType } from '@core/components/m-label/types'

const props = defineProps<{
  type: LabelType
  provider: Provider
  messageKey?: string
  detailsText?: string
}>()

const modalOpen = ref(false)

const { $t, $i18next } = useNuxtApp()

const slots = useSlots()

const details = computed(() => {
  if (slots.modalContent) {
    return true
  }
  if (props.detailsText) {
    return props.detailsText
  }
  if (props.messageKey && $i18next.exists(`${props.messageKey}_details`)) {
    return $t(`${props.messageKey}_details`)
  }
  return false
})
</script>
